import React from 'react';
import DetailTable from './detailTable';

export default (props) => <DetailTable {...props} />;
